module.exports = __webpack_public_path__ + "img/signal-1.621747f5.svg";